import type { JSXProps, JSXChild } from 'engine/index';

type BadgeProps = {
	status?: 'neutral' | 'success' | 'info' | 'warn' | 'danger';
} & JSXProps;

export function Badge(props: BadgeProps, ...children: JSXChild[]) {
	const status = props.status ?? 'neutral';

	const modes: Record<typeof status, string> = {
		neutral: 'border-gray-400 text-gray-900 bg-gray-200 dark:border-gray-700 dark:text-gray-50 dark:bg-gray-500',
		success: 'border-success-400 text-success-900 bg-success-200 dark:border-success-700 dark:text-success-50 dark:bg-success-500',
		info: 'border-info-400 text-info-900 bg-info-200 dark:border-info-700 dark:text-info-50 dark:bg-info-500',
		warn: 'border-warn-400 text-warn-900 bg-warn-200 dark:border-warn-700 dark:text-warn-50 dark:bg-warn-500',
		danger: 'border-danger-400 text-danger-900 bg-danger-200 dark:border-danger-700 dark:text-danger-50 dark:bg-danger-500',
	};

	return (
		<div {...props} class={modes[status] + ' inline-block rounded-full border px-2 text-[10px]'}>
			{children}
		</div>
	);
}
